import { Box, Stack, Typography } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OperationIcon from "src/assets/svg-icons/side-bar/operation.svg";
import SalaryMainTabs from "./tabs";

// Full-page children that render their own header and breadcrumb instead of the
// module chrome (title + tabs).
const standalonePagePath = (pathname: string) =>
  /\/salary\/employees\/new\/?$/.test(pathname) ||
  /\/salary\/employees\/\d+\/edit\/?$/.test(pathname) ||
  /\/salary\/employees\/\d+\/?$/.test(pathname) ||
  /\/salary\/salaries\/\d+\/?$/.test(pathname);

const SalaryModulePage = () => {
  const { t } = useTranslation("salary");
  const { pathname } = useLocation();
  const hideModuleChrome = standalonePagePath(pathname);

  if (hideModuleChrome) {
    return <Outlet />;
  }

  return (
    <Stack
      gap={3}
      p={{ xs: 2, sm: "8px 32px 32px 32px" }}
      sx={{ width: "100%", minWidth: 0 }}
    >
      <Stack
        direction="row"
        spacing="12px"
        alignItems="center"
        color="#101828"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="60px"
          height="60px"
          bgcolor="#D0D5DD"
          borderRadius="16px"
        >
          <img src={OperationIcon} width="32px" alt="" />
        </Box>
        <Typography fontSize="32px" lineHeight="38.4px">
          {t("payroll")}
        </Typography>
      </Stack>
      <Box bgcolor="#F2F4F7" width="100%" height="1px" />
      <SalaryMainTabs />
      <Outlet />
    </Stack>
  );
};

export default SalaryModulePage;
